import React, { useContext, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import DashboardItem from "./DashboardItem";
import { getRedirectType, isEmptyObject, isMobileDevice } from "../../utils/Utils";

import useD2C from "../../hooks/useD2C";
import usePurchasedPackage from "./usePurchasedPackage";
import GLOBAL from "../../global";
import useChatbot from "../shared/chatbotNew/hooks/useChatbot";
import examService from "../../services/ExamService";
import CONSTANT from "../../constants/Constant";
import {
    setIsShowIsFollowUpPopup, setOpenBiometricMovementAndCautionQuestionContainer,
    setSelectedTelemedicineInvitationId,
    setShowLoadingAtJoinNowBtn, setShowLoadingInConformTelemedicine
} from "../../features/dashboard/dashboardSlice";
import useSweetAlert from "../shared/Popups/sweetAlertComponent/useSweetAlert";
import AppContext from "../../contexts/AppContext";
import { _getInCompleteAssessmentType, getResumeGroupFromId } from "./dashboardUtills";
import routes from "../../constants/Routes";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import DirectToConsumerService from "../../services/DirectToConsumerService";
import { PlusIcon } from "../../assets/svg/AlertModal/plus";
import { ReloadIcon } from "../../assets/svg/AlertModal/reload";
import AlertModal from "../AlertModal/AlertModal";
import NewAlertModal from "../shared/AlertModal";
import MobileAppSuggestionsModal from "../MobileAppSuggestions/MobileAppSuggestionsModal";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";
import useDeviceCompatibility from "../../hooks/useDeviceCompatibility";

const StartNewAssessment = ({
    callbackFetchNotificationData,
    packages: externalPackages,
    setOpenBiometricMovementAndCautionQuestionContainer,
    refreshPackages
}) => {
    const [showAssessmentPurchaseModal, setShowAssessmentPurchaseModal] = useState(false);
    const [invitationRequestResponse, setInvitationRequestResponse] = useState(false);
    const [isNewAssessmentLoading, setIsNewAssessmentLoading] = useState(false);
    const [isFollowUpLoading, setIsFollowUpLoading] = useState(false);
    const [showMobileAppSuggestion, setShowMobileAppSuggestion] = useState(false);
    const [pendingStartParams, setPendingStartParams] = useState(null);
    const dispatch = useDispatch();
    const { IsD2CEnabled } = useD2C();
    const { createAssessmentFromPackage } = usePurchasedPackage();
    const { startChatBot } = useChatbot();
    const { showSweetAlert, hideSweetAlert } = useSweetAlert();
    const { setTelemedicineProperties, resetTelemedicineKeys, setSelectedTabForEditAssessment } = useContext(AppContext);
    const history = useHistory();

    const notificationInformationOfSelectedAssessment = useRef({});

    const { isMobileAppSuggestionModalEnabled } = useDeviceCompatibility();

    // Filter packages to only show those with balance > 0 and not expired
    const packages = (externalPackages || []).filter(pkg => pkg.balance > 0 && !pkg.isExpired);

    const handleStartButtonClick = (pak) => {
        if (isMobileAppSuggestionModalEnabled && isMobileDevice()) {
            // Store parameters and show mobile app suggestion modal
            console.log('Showing mobile app suggestion modal');
            setPendingStartParams(pak);
            setShowMobileAppSuggestion(true);
            return;
        }

        // Execute the existing flow
        executeStartFlow(pak);
    };

    const executeStartFlow = (pak) => {
        createAssessmentFromPackage(
            pak?.orderId,
            callbackFetchNotificationData,
            setShowAssessmentPurchaseModal,
            setInvitationRequestResponse,
            refreshPackages
        );
    };

    const onContinueWithWeb = () => {
        setShowMobileAppSuggestion(false);
        if (pendingStartParams) {
            executeStartFlow(pendingStartParams);
            setPendingStartParams(null);
        }
    };

    const onCancelMobileAppSuggestion = () => {
        setShowMobileAppSuggestion(false);
        setPendingStartParams(null);
    };

    const onConfirmNewAssessment = async () => {
        setIsNewAssessmentLoading(true);
        try {
            let response = await DirectToConsumerService.invitationRequest({ OrderId: invitationRequestResponse?.OrderId });
            if (response.success) {
                // Refresh MyAssessments data
                if (callbackFetchNotificationData) {
                    console.log('inside onConfirmNewAssessment')
                    callbackFetchNotificationData();
                }
                // Refresh packages data
                if (refreshPackages) {
                    refreshPackages();
                }
                const data = response?.data;
                if (data && data?.InvitationId && data?.InvitationTypeId && data?.BodyRegionIds && data?.MeetingStartDate && data?.MeetingEndDate) {
                    // Refresh MyAssessments data
                    if (callbackFetchNotificationData) {
                        console.log('inside onConfirmNewAssessment')
                        callbackFetchNotificationData();
                    }
                    // Refresh packages data
                    if (refreshPackages) {
                        refreshPackages();
                    }

                    const bodyRegionList = data?.BodyRegionIds.split(',').map(Number).filter(Boolean) || []

                    startChatBot(
                        {
                            InvitationId: data?.InvitationId,
                            BodyRegionList: bodyRegionList,
                            InvitationTypeName: getRedirectType(data?.InvitationTypeId),
                        },
                        GLOBAL?.USER_INFO?.ContactId || '', //patientId
                        data?.MeetingEndDate || '', //meetingStart
                        data?.MeetingStartDate || '', //meetingEnd
                        () => {
                            // Refresh MyAssessments data
                            if (callbackFetchNotificationData) {
                                console.log('inside startChatBot')
                                callbackFetchNotificationData();
                            }
                            // Refresh packages data
                            if (refreshPackages) {
                                refreshPackages();
                            }

                            // Callback after chatbot starts
                            setShowAssessmentPurchaseModal(false);
                            setIsNewAssessmentLoading(false);
                        }
                    )

                } else {
                    setIsNewAssessmentLoading(false);
                }
                setShowAssessmentPurchaseModal(false);
                // Refresh MyAssessments data
                if (callbackFetchNotificationData) {
                    callbackFetchNotificationData();
                }
            } else {
                toast.error("Failed to start assessment, please try again later");
                setIsNewAssessmentLoading(false);
            }
        } catch (error) {
            toast.error("Failed to start assessment, please try again later");
            setIsNewAssessmentLoading(false);
        }
    };

    const onOpenTelemedicineModal = () => {
        setIsShowIsFollowUpPopup(false);
    };

    const onCloseTelemedicineModal = () => {
        resetTelemedicineKeys();
        dispatch(setSelectedTelemedicineInvitationId(null));
        dispatch(setShowLoadingAtJoinNowBtn(false));
        dispatch(setShowLoadingInConformTelemedicine(false));
    };

    const openBiometricCautionQuestionModal = (notification) => {
        // If setOpenBiometricMovementAndCautionQuestionContainer prop is provided (from MyAssessments),
        // use it directly instead of Redux dispatch
        if (setOpenBiometricMovementAndCautionQuestionContainer) {
            setOpenBiometricMovementAndCautionQuestionContainer({
                testId: notification.TestId,
                bodyRegionList: notification.BodyRegionList
            });
        } else {
            // Fallback to Redux dispatch for Dashboard usage
            dispatch(setOpenBiometricMovementAndCautionQuestionContainer({
                openBiometricMovementAndCautionQuestionContainer: true,
                testId: notification.TestId,
                selectedBodyRegions: notification.BodyRegionList
            }));
        }
    }

    const redirectToEditAssessmentPage = (notification) => {
        notificationInformationOfSelectedAssessment.current = notification
        let firstInCompletedGroup = getResumeGroupFromId(notification?.ResumeGroupId);
        let keyOfFirstIncompleteGroup = CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;
        if (!isEmptyObject(firstInCompletedGroup)) {
            keyOfFirstIncompleteGroup = firstInCompletedGroup?.key || CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;
            if (keyOfFirstIncompleteGroup === CONSTANT.ASSESSMENT_GROUP.BIOMETRIC.key) keyOfFirstIncompleteGroup = CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key
        }
        setSelectedTabForEditAssessment(keyOfFirstIncompleteGroup);

        // setRedirectToAssessmentPage(true)
        // redirectTo(`${routes.editAssessment}/${notificationInformationOfSelectedAssessment.current.TestId}?groupId=${getResumeGroupFromId(notificationInformationOfSelectedAssessment.current?.ResumeGroupId)?.key}`)
        history.push(`${routes.editAssessment}/${notificationInformationOfSelectedAssessment.current.TestId}?groupId=${getResumeGroupFromId(notificationInformationOfSelectedAssessment.current?.ResumeGroupId)?.key}`)
    }

    const onCancelFollowUpAssessment = async () => {
        if (!invitationRequestResponse) return;

        setIsFollowUpLoading(true);
        try {
            let invitationRequestApiResponse = await DirectToConsumerService.invitationRequest({ OrderId: invitationRequestResponse?.OrderId });
            if (invitationRequestApiResponse.success) {
                const invitationRequestResponse = invitationRequestApiResponse?.data;
                const response = await examService.followUp({
                    InvitationId: invitationRequestResponse.InvitationId,
                    BaseTestId: invitationRequestResponse.BaseTestId,
                    StartTime: invitationRequestResponse.MeetingStartDate,
                    EndTime: invitationRequestResponse.MeetingEndDate,
                    TimeZone: invitationRequestResponse.TimeZone
                });
                const { data, success } = response;

                if (success) {
                    // Refresh MyAssessments data
                    if (callbackFetchNotificationData) {
                        console.log('inside onCancelFollowUpAssessment')
                        callbackFetchNotificationData();
                    }
                    // Refresh packages data
                    if (refreshPackages) {
                        refreshPackages();
                    }
                    setShowAssessmentPurchaseModal(false);
                    setIsFollowUpLoading(false);
                    showSweetAlert({
                        title: 'Update Your Information?',
                        message: 'Would you like to update your background information (Activities of Daily Living, Medical History, Chief Complaints)?',
                        type: CONSTANT.ALERT_TYPE.INFO,
                        onConfirm: () => {
                            hideSweetAlert();
                            // Refresh data after sweet alert actions
                            if (callbackFetchNotificationData) {
                                callbackFetchNotificationData();
                            }
                            if (refreshPackages) {
                                refreshPackages();
                            }

                            if (+invitationRequestResponse?.InvitationTypeId === CONSTANT.INVITATION_TYPE.Telemedicine) {
                                setTelemedicineProperties(invitationRequestResponse.InvitationId, invitationRequestResponse.BodyRegionList, onOpenTelemedicineModal, onCloseTelemedicineModal);
                                dispatch(setSelectedTelemedicineInvitationId(invitationRequestResponse.InvitationId));
                            } else if (+invitationRequestResponse?.InvitationTypeId === CONSTANT.INVITATION_TYPE.Self) {
                                // Store the notification data for the biometric modal
                                notificationInformationOfSelectedAssessment.current = {
                                    ...invitationRequestResponse,
                                    TestId: data.TestId
                                };
                                openBiometricCautionQuestionModal({
                                    ...invitationRequestResponse,
                                    TestId: data.TestId
                                });
                            } else {
                                // For other invitation types, redirect to edit assessment page
                                redirectToEditAssessmentPage({ ...invitationRequestResponse, TestId: data.TestId });
                            }
                        },
                        onClose: () => {
                            hideSweetAlert();
                            // Refresh data when dialog is closed
                            if (callbackFetchNotificationData) {
                                callbackFetchNotificationData();
                            }
                            if (refreshPackages) {
                                refreshPackages();
                            }
                        },
                        showCloseBtn: true,
                        onCancel: () => {
                            hideSweetAlert();
                            // Refresh data after cancel action
                            if (callbackFetchNotificationData) {
                                callbackFetchNotificationData();
                            }
                            if (refreshPackages) {
                                refreshPackages();
                            }
                            redirectToEditAssessmentPage({ ...invitationRequestResponse, TestId: data.TestId });
                        },
                        showCancelBtn: true,
                        showConfirmBtn: +invitationRequestResponse?.InvitationTypeId !== CONSTANT.INVITATION_TYPE.InClinic,
                        showOkBtn: false,
                        confirmBtnText: +invitationRequestResponse?.InvitationTypeId !== CONSTANT.INVITATION_TYPE.InClinic ? 'Resume Assessment' : '',
                        cancelBtnText: 'Update My Background',
                    });
                } else {
                    setIsFollowUpLoading(false);
                }
            } else {
                toast.error("Failed to start assessment, please try again later");
                setIsFollowUpLoading(false);
            }
        } catch (error) {
            toast.error("Failed to start assessment, please try again later");
            setIsFollowUpLoading(false);
        }
    };

    const toggleAssessmentPurchaseModal = () => {
        setShowAssessmentPurchaseModal(false);
        setIsNewAssessmentLoading(false);
        setIsFollowUpLoading(false);
    };

    const InfoIcon = () => (
        <svg fill="#ffffff" width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="M12,14a1,1,0,0,0,1-1V7a1,1,0,0,0-2,0v6A1,1,0,0,0,12,14Zm0,4a1.25,1.25,0,1,0-1.25-1.25A1.25,1.25,0,0,0,12,18Z" /></svg>
    );


    return (
        <div className="purchase-package w-100-percent"
            style={{ marginLeft: '0 !important', paddingLeft: '0 !important' }}>
            {(packages.length > 0 && IsD2CEnabled) && (
                <DashboardItem largeTitle={`Start New Assessment`} overflow={false} showOnlyOneImage={false}>
                    <div className="mt-3">
                        {packages.map((pak, index) => (
                            <div key={index} className="start-new-assessment-item d-flex mmh-flex-wrap justify-content-between mmh-align-items-center bg-color-white padding-1-rem w-100-percent mb-3" style={{ border: '1px solid #dee2e6', borderRadius: '12px' }}>
                                <div className="start-new-assessment-item__title font-size-md font-wight-500 padding-12px">
                                    {pak.packageName}
                                </div>
                                <div className="start-new-assessment-item__button-container padding-12px">
                                    <button
                                        className="button button-dashboard rounded-btn"
                                        onClick={() => handleStartButtonClick(pak)}
                                        disabled={false}
                                        style={{ minWidth: '120px' }}
                                    >
                                        Start
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    <AlertModal
                        isOpen={showAssessmentPurchaseModal}
                        onClose={() => toggleAssessmentPurchaseModal}
                        icon={<InfoIcon />}
                        title="What would you like to do today?"
                        description={
                            <>
                                <p style={{ marginBottom: '0.75rem', textWrap: 'wrap' }}>
                                    <strong>New:</strong> Start a new assessment with a different sport selection.
                                </p>
                                <p style={{ textWrap: "wrap" }}>
                                    <strong>Follow Up:</strong> Continue from your last assessment update background details if needed or go straight to biometric movement.
                                </p>
                            </>
                        }
                        buttons={[
                            {
                                label: isNewAssessmentLoading ? "Loading..." : 'New',
                                icon: <PlusIcon />,
                                variant: 'primary',
                                onClick: onConfirmNewAssessment,
                                disabled: isNewAssessmentLoading
                            },
                            {
                                label: isNewAssessmentLoading ? "Loading..." : 'Follow Up',
                                icon: <ReloadIcon />,
                                variant: 'primary',
                                onClick: onCancelFollowUpAssessment,
                                disabled: isNewAssessmentLoading
                            },
                        ]}
                        overlayClosable={false}
                        showCloseButton={false}
                    />

                    {showMobileAppSuggestion && (
                        <NewAlertModal
                            show={showMobileAppSuggestion}
                            confirmBtnCssClass="btn btn-sm btn-secondary"
                            // confirmBtnText="Cancel"
                            title='Device Compatibility Notice'
                            // onConfirm={onCancelMobileAppSuggestion}
                            closeOnClickOutside={false}
                            showConfirm={false}
                        >
                            <MobileAppSuggestionsModal />
                        </NewAlertModal>
                    )}
                </DashboardItem>
            )}
        </div>
    );
}

export default StartNewAssessment;
